import { POST_SCHOOL_CANDIDATE_CONFIRM_AND_PAY } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {
  ExamProceedToPaymentRequestBody,
  ExamProceedToPaymentResponseBody,
} from '../../api/candidate/exam/model';

interface Input {
  onSuccess?: () => void;
  onError?: () => void;
}

export const usePostSchoolCandidateConfirmAndPay = ({ onSuccess, onError }: Input) => {
  const postScholCandidateConfirmAndPay = async (payload: ExamProceedToPaymentRequestBody) => {
    const res = await axiosClient.post<ExamProceedToPaymentResponseBody>(
      POST_SCHOOL_CANDIDATE_CONFIRM_AND_PAY,
      payload
    );

    return res.data;
  };

  return useCustomMutation(
    postScholCandidateConfirmAndPay,
    {
      onSuccess,
      onError,
    },
    false,
    false
  );
};
